import { Step2ValueModel, Step3ValueModel } from './types'
import {
    validateChangeOwner,
    validateChangeOwnerDate,
    validateAccountType,
    validateBg,
    validatePg,
    validateCompanyName,
    validateStreetBox,
    validateZipCode,
    validateCity,
    validateMunicipality,
    validateHasRvm,
    validateRvmEmail,
    validateVisitingAddressStreetAddress,
    validateVisitingAddressZipCode,
    validateVisitingAddressCity,
    validatePostalAddressStreetBox,
    validatePostalAddressZipCode,
    validatePostalAddressCity,
    validateDeliveryAddressStreetAddress,
    validateDeliveryAddressZipCode,
    validateDeliveryAddressCity,
    validateSignatoryFirstName,
    validateSignatoryLastName,
    validateSignatoryEmail,
    validateInvoiceAddressStreetAddress,
    validateInvoiceAddressZipCode,
    validateInvoiceAddressCity,
    validateInvoiceAddressEmail,
    validateVat,
} from '../shared/Validation'
import { AccountType } from '../shared/types'
import { FormErrorType } from "@sharedComponents/PantaForm/types";
import { validateRequired } from "@sharedComponents/PantaForm/utils";
import i18n from "@apps/Shared/translation/i18n";

export const validateStoreName = (
    storeName: string | undefined,
    currentErrors: FormErrorType[]
) => {
    const errors = validateRequired(
        storeName,
        'storeName',
        i18n.t('error.emptyStoreName'),
        currentErrors
    )

    return errors
}

export const validateStep2 = async (
    stepValues: Step2ValueModel,
    currentErrors: FormErrorType[]
) => {
    let errors = [...currentErrors]

    errors = validateChangeOwner(stepValues.changeOwner, errors)
    errors = validateChangeOwnerDate(
        stepValues.changeOwnerDate,
        stepValues.changeOwner === 'true',
        errors
    )
    errors = validateCompanyName(stepValues.companyName, errors)
    errors = validateAccountType(stepValues.accountType, true, errors)
    if (stepValues.registeredForVAT === 'true') {
        errors = validateVat(stepValues.vatNumber, errors)
    }
    errors = validateBg(
        stepValues.bg,
        stepValues.accountType === AccountType.Bg,
        errors
    )
    errors = validatePg(
        stepValues.pg,
        stepValues.accountType === AccountType.Pg,
        errors
    )
    errors = validateStreetBox(stepValues.streetBox, errors)
    errors = validateZipCode(stepValues.zipCode, true, errors)
    errors = validateCity(stepValues.city, errors)

    return errors
}

export const validateStep3 = async (
    stepValues: Step3ValueModel,
    currentErrors: FormErrorType[]
) => {
    let errors = [...currentErrors]

    errors = validateStoreName(stepValues.storeName, errors)
    errors = validateMunicipality(stepValues.municipality, errors)
    errors = validateHasRvm(stepValues.hasRvm, errors)
    errors = validateRvmEmail(
        stepValues.rvmEmail,
        stepValues.hasRvm === 'true',
        errors
    )
    if (stepValues.hasRvm === 'true') {
        errors = validateSignatoryFirstName(
            stepValues.signatory?.firstName,
            errors
        )
        errors = validateSignatoryLastName(
            stepValues.signatory?.lastName,
            errors
        )
        errors = validateSignatoryEmail(stepValues.signatory?.email, errors)
        errors = validateInvoiceAddressStreetAddress(
            stepValues.invoiceAddress?.streetAddress,
            errors
        )
        errors = validateInvoiceAddressZipCode(
            stepValues.invoiceAddress?.zipCode,
            true,
            errors
        )
        errors = validateInvoiceAddressCity(
            stepValues.invoiceAddress?.city,
            errors
        )
        errors = validateInvoiceAddressEmail(
            stepValues.invoiceAddress?.email,
            errors
        )
    }
    errors = validateVisitingAddressStreetAddress(
        stepValues.visitingAddress.streetAddress,
        errors
    )
    errors = validateVisitingAddressZipCode(
        stepValues.visitingAddress.zipCode,
        true,
        errors
    )
    errors = validateVisitingAddressCity(
        stepValues.visitingAddress.city,
        errors
    )
    errors = validatePostalAddressStreetBox(
        stepValues.postalAddress.streetBox,
        stepValues.visitingAddress.isAlsoPostalAddress !== true,
        errors
    )
    errors = validatePostalAddressZipCode(
        stepValues.postalAddress.zipCode,
        stepValues.visitingAddress.isAlsoPostalAddress !== true,
        true,
        errors
    )
    errors = validatePostalAddressCity(
        stepValues.postalAddress.city,
        stepValues.visitingAddress.isAlsoPostalAddress !== true,
        errors
    )
    if (stepValues.hasRvm === 'true') {
        errors = validateDeliveryAddressStreetAddress(
            stepValues.deliveryAddress?.streetAddress,
            stepValues.visitingAddress.isAlsoPostalAddress !== true,
            errors
        )
        errors = validateDeliveryAddressZipCode(
            stepValues.deliveryAddress?.zipCode,
            stepValues.visitingAddress.isAlsoPostalAddress !== true,
            true,
            errors
        )
        errors = validateDeliveryAddressCity(
            stepValues.deliveryAddress?.city,
            stepValues.visitingAddress.isAlsoPostalAddress !== true,
            errors
        )
    }

    return errors
}